module.exports = __webpack_public_path__ + "static/media/8mar.8b42b93f.jpg";